import { PkOverlay } from '@uefadigital/panenka-react';
import clsx from 'clsx';
import { memo, useEffect, useRef } from 'react';

import { useHeaderOptions } from '../../model';

import CompetitionFeatured from './CompetitionFeatured';
import Featured from './Featured';
import QuickLinks from './QuickLinks';
import UefaCompetitions from './UefaCompetitions';

import * as styles from './styles.module.scss';

const Overlay = ({ open, onClose }: { open: boolean; onClose: () => unknown }) => {
  const { options } = useHeaderOptions();

  const featured = options.menu.find((m) => m.id === 'featured');
  const quickLinks = options.menu.find((m) => m.id === 'quick-links');
  const uefaCompetitions = options.menu.find((m) => m.id === 'uefa-competitions');
  const competitionFeaturedLinks = options.menu.find((m) => m.id === 'comp-featuring');
  const overlayRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (open && overlayRef.current) {
      overlayRef.current.focus();
    }
  }, [open]);

  return (
    <PkOverlay
      pk-theme={options.theme}
      pk-competition='base'
      isOpen={open}
      onPkOverlayClose={onClose}
      openFromTop
      className={clsx(
        styles.overlay,
        open && styles.overlayOpen,
        options.isCompetitionContext && styles.overlayCompetition,
      )}
      aria-hidden={!open}
      tabIndex={open ? undefined : -1}
    >
      <div
        className={clsx(
          styles.overlayContent,
          'pk-w--100 pk-d--flex pk-flex--column pk-flex-md--row pk-gap-md--xl3',
          options.isCompetitionContext ? 'pk-gap--0' : 'pk-gap--m',
        )}
      >
        {featured && <Featured item={featured} />}
        {options.isCompetitionContext ? (
          <div className={clsx(styles.competition, styles.leftColumn)}>
            <CompetitionFeatured item={competitionFeaturedLinks} />
            <QuickLinks item={quickLinks} isCompetition />
          </div>
        ) : (
          <QuickLinks item={quickLinks} />
        )}

        <UefaCompetitions item={uefaCompetitions} />
      </div>
    </PkOverlay>
  );
};

export default memo(Overlay);
